import React from 'react';
import type { TemplateEditorContainerPropTypes } from './utils/document-editor.types';
import { DocxNativeTemplateEditorContainer } from './docx-native/DocxNativeTemplateEditorContainer';

/**
 * Editor entry point for TEMPLATES (sibling of `DocumentEditorSwitch`, which
 * does the same for deal documents).
 *
 * This WAS the two-engine switch that carried the V4.0 migration. CKEditor has
 * been removed, so every template opens in the DOCX-native editor. Kept as a
 * component because it is the stable seam the pages import.
 *
 * The separate header/footer editor UI is intentionally not wired — the
 * DOCX-native editor edits headers and footers inline.
 */

export type EditorEngine = 'docx_native';

export interface EditorSwitchProps extends TemplateEditorContainerPropTypes {
  /** Accepted for call-site compatibility; no longer selects anything. */
  editorEngine?: EditorEngine | string | null;
}

export const EditorSwitch: React.FC<EditorSwitchProps> = ({ editorEngine: _editorEngine, ...props }) => (
  <DocxNativeTemplateEditorContainer {...props} />
);
